import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSearch, faCamera } from '@fortawesome/free-solid-svg-icons';

const DigitalTryout = () => {
  const [items, setItems] = useState([
    // Jewellery - Affordable to Luxury
    { id: 1, name: 'Silver Hoop Earrings', category: 'Jewellery', price: 500, description: 'Simple silver hoops for everyday wear.', imageUrl: 'https://via.placeholder.com/300x300?text=Silver+Hoops', position: { top: '30%', left: '45%' }, class: 'affordable' },
    { id: 2, name: 'Gold Necklace', category: 'Jewellery', price: 2000, description: 'Elegant gold chain with pendant.', imageUrl: 'https://via.placeholder.com/300x300?text=Gold+Necklace', position: { top: '20%', left: '50%' }, class: 'mid-range' },
    { id: 3, name: 'Diamond Stud Earrings', category: 'Jewellery', price: 15000, description: 'Luxury diamond studs for special occasions.', imageUrl: 'https://via.placeholder.com/300x300?text=Diamond+Studs', position: { top: '30%', left: '45%' }, class: 'luxury' },
    { id: 4, name: 'Ethnic Bangles Set', category: 'Jewellery', price: 800, description: 'Traditional glass bangles for cultural events.', imageUrl: 'https://via.placeholder.com/300x300?text=Ethnic+Bangles', position: { top: '40%', left: '20%' }, class: 'affordable' },

    // Clothing - Diverse styles
    { id: 5, name: 'Cotton T-Shirt', category: 'Clothing', price: 300, description: 'Comfortable casual t-shirt in pastel colors.', imageUrl: 'https://via.placeholder.com/300x300?text=Cotton+T-Shirt', position: { top: '25%', left: '30%', width: '40%' }, class: 'affordable' },
    { id: 6, name: 'Silk Saree', category: 'Clothing', price: 5000, description: 'Traditional silk saree with embroidery.', imageUrl: 'https://via.placeholder.com/300x300?text=Silk+Saree', position: { top: '10%', left: '10%', width: '80%' }, class: 'mid-range' },
    { id: 7, name: 'Designer Gown', category: 'Clothing', price: 25000, description: 'High-end evening gown for formal events.', imageUrl: 'https://via.placeholder.com/300x300?text=Designer+Gown', position: { top: '10%', left: '10%', width: '80%' }, class: 'luxury' },
    { id: 8, name: 'Kurta Set', category: 'Clothing', price: 1200, description: 'Comfortable ethnic kurta for daily wear.', imageUrl: 'https://via.placeholder.com/300x300?text=Kurta+Set', position: { top: '20%', left: '20%', width: '60%' }, class: 'affordable' },

    // Accessories
    { id: 9, name: 'Leather Handbag', category: 'Accessories', price: 1500, description: 'Stylish handbag for work or outings.', imageUrl: 'https://via.placeholder.com/300x300?text=Leather+Bag', position: { top: '60%', left: '10%' }, class: 'mid-range' },
    { id: 10, name: 'Sunglasses', category: 'Accessories', price: 800, description: 'Trendy sunglasses for summer.', imageUrl: 'https://via.placeholder.com/300x300?text=Sunglasses', position: { top: '15%', left: '40%' }, class: 'affordable' },
    { id: 11, name: 'Designer Scarf', category: 'Accessories', price: 3000, description: 'Luxury silk scarf.', imageUrl: 'https://via.placeholder.com/300x300?text=Designer+Scarf', position: { top: '20%', left: '50%' }, class: 'luxury' },

    // Makeup - Variety
    { id: 12, name: 'Red Lipstick', category: 'Makeup', price: 400, description: 'Matte red lipstick for bold looks.', imageUrl: 'https://via.placeholder.com/300x300?text=Red+Lipstick', position: { top: '40%', left: '50%' }, class: 'affordable' },
    { id: 13, name: 'Eyeshadow Palette', category: 'Makeup', price: 2500, description: 'Professional eyeshadow palette.', imageUrl: 'https://via.placeholder.com/300x300?text=Eyeshadow', position: { top: '25%', left: '45%' }, class: 'mid-range' },
    { id: 14, name: 'Highlighter Set', category: 'Makeup', price: 8000, description: 'Premium highlighter for glowy skin.', imageUrl: 'https://via.placeholder.com/300x300?text=Highlighter', position: { top: '30%', left: '50%' }, class: 'luxury' },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [showTryout, setShowTryout] = useState(false);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const overlayRef = useRef(null);

  const filteredItems = items.filter(item =>
    item.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const categories = [...new Set(items.map(item => item.category))];

  useEffect(() => {
    if (showTryout && selectedItem) {
      const startCamera = async () => {
        try {
          const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true });
          setStream(mediaStream);
          if (videoRef.current) {
            videoRef.current.srcObject = mediaStream;
          }
        } catch (err) {
          console.error('Error accessing camera:', err);
          alert('Camera access denied or not available.');
          setShowTryout(false);
        }
      };
      startCamera();
    }

    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, [showTryout, selectedItem]);

  const handleTryout = () => {
    setShowTryout(true);
  };

  const closeTryout = () => {
    setShowTryout(false);
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
      setStream(null);
    }
  };

  const closeDetails = () => {
    setSelectedItem(null);
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-2 sm:p-4">
      {/* Header */}
      <header className="mb-6 text-center">
        <h1 className="text-lg sm:text-xl font-bold text-pink-300 mb-2">Think5Whys AI Powered Digital Tryout</h1>
        <p className="text-pink-200 text-sm">Discover online and try fashion for every woman. </p>
      </header>

      {/* Search Bar */}
      <div className="mb-6">
        <div className="relative">
          <FontAwesomeIcon
            icon={faSearch}
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-pink-400 text-sm"
          />
          <input
            type="text"
            placeholder="Search by category or item..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-3 bg-gray-800 border border-pink-500 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-pink-500"
          />
        </div>
      </div>

      {/* Category Tabs - Optional, but since search is there, maybe list directly */}
      {/* Items Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        {filteredItems.map((item) => (
          <div
            key={item.id}
            className="bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
            onClick={() => setSelectedItem(item)}
          >
            <img
              src={item.imageUrl}
              alt={item.name}
              className="w-full h-48 object-cover"
            />
            <div className="p-4">
              <h3 className="font-semibold text-pink-300 text-sm mb-1">{item.name}</h3>
              <p className="text-gray-400 text-xs mb-1">{item.category}</p>
              <p className="text-pink-400 font-medium">₹{item.price}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Details Modal */}
      {selectedItem && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 rounded-lg max-w-sm w-full relative">
            <button
              onClick={closeDetails}
              className="absolute top-2 right-2 text-gray-400 w-10 hover:text-white text-xl"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
            <img
              src={selectedItem.imageUrl}
              alt={selectedItem.name}
              className="w-full h-64 object-contain mx-auto mt-8"
            />
            <div className="p-4">
              <h3 className="font-bold text-xl text-pink-300 mb-2">{selectedItem.name}</h3>
              <p className="text-gray-300 mb-2">{selectedItem.description}</p>
              <p className="text-pink-400 font-semibold mb-4">₹{selectedItem.price} - {selectedItem.class.charAt(0).toUpperCase() + selectedItem.class.slice(1)} Range</p>
              <button
                onClick={handleTryout}
                className="w-full bg-pink-600 hover:bg-pink-700 text-white py-3 rounded-lg font-medium flex items-center justify-center gap-2"
              >
                <FontAwesomeIcon icon={faCamera} />
                Try On
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Tryout Modal */}
      {showTryout && selectedItem && (
        <div className="fixed inset-0 bg-black z-50 flex flex-col items-center justify-center p-4">
          <button
            onClick={closeTryout}
            className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl z-10"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="relative w-full max-w-md mx-auto aspect-video bg-gray-800 rounded-lg overflow-hidden">
            <video
              ref={videoRef}
              autoPlay
              playsInline
              className="absolute inset-0 w-full h-full object-cover"
            />
            <img
              ref={overlayRef}
              src={selectedItem.imageUrl}
              alt={selectedItem.name}
              className="absolute"
              style={{
                top: selectedItem.position.top,
                left: selectedItem.position.left,
                width: selectedItem.position.width || '20%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
              }}
            />
          </div>
          <p className="mt-4 text-center text-pink-300">Position your face/body to try on {selectedItem.name}</p>
        </div>
      )}
    </div>
  );
};

export default DigitalTryout;